import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

import styles from './style.module.scss'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import { convertDt24hFormat, getImgURL, abbreviateNumber, dateCheck, checkPageNumberInSlug } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64, DEFAULT_BLOG_READ, WIDGET } from '@shared-submodule/sm-constants'
import Layout from '../layout'
import { GET_ARTICLE_VIEWS, GET_FANTASY_ARTICLE_VIEWS } from '@graphql/article/article.query'
import { useLazyQuery } from '@apollo/client'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import MyImage from '@shared/components/myImage'
import AllWidget from '@shared/components/allWidget'
import CustomLink from '../customLink'
import BreadcrumbNav from '@shared/components/breadcrumbNav'
import ArticleActions from '@shared/components/articleDetail/articleActions'
import TrendingNewsArticle from '../trandingNewsArticle'
import View from '@assets/images/placeholder/view.svg'
import LiveBlog from '../liveArticle/liveBlogTimeLine'
import StaticBanner from '../staticBanner'
// import TrendingNews from '../trendingNews'÷
// import ChessPopAdMweb from '../chess/chessPopAd/chessPopAdMweb'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import { skyAddData } from '@shared/constants/skyAds'
import useWindowSize from '@shared/hooks/windowSize'
// import { googleNewAdsData } from '../adsData'
import TopTennisPlayers from '../widgets/topTennisPlayers'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const TopTeams = dynamic(() => import('@shared/components/widgets/topTeams'), { ssr: false })
const TrendingSeries = dynamic(() => import('@shared/components/widgets/trendingSeries'), { ssr: false })
const ExclusiveIcon = dynamic(() => import('@shared/components/ctIcons/exclusiveIcon'), { ssr: false })
const EditorsPickIcon = dynamic(() => import('@shared/components/ctIcons/editorsPickIcon'), { ssr: false })
const LazyLoad = dynamic(() => import('@shared/components/lazyLoad'), { ssr: false })
// const DownloadApp = dynamic(() => import('@shared/components/downloadApp'))
const Comments = dynamic(() => import('@shared/components/comments'))
const OnMouseAndScroll = dynamic(() => import('@shared/components/lazyLoad/onMouseAndScroll'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
function ArticleDetail({ article, isPreviewMode, seoData, children, type, liveArticle }) {
  const router = useRouter()
  const [width] = useWindowSize()
  const isFootball = router?.asPath?.startsWith('/football-news/')
  const isTennis = router?.asPath?.startsWith('/tennis-news/')
  const { t } = useTranslation()
  const [articleViews, setArticleViews] = useState(article?.nViewCount || article?.nOViews || 0)
  const [page, setPage] = useState(1)
  const [commentCount, setCommentCount] = useState(article?.nCommentCount || 0)

  const [getArticleViews] = useLazyQuery(GET_ARTICLE_VIEWS, {
    onCompleted: data => {
      if (data && data?.getArticleFront) {
        setArticleViews(data?.getArticleFront?.nViewCount || data?.getArticleFront?.nOViews || 0)
      }
    }
  })
  const [getFantasyArticleViews] = useLazyQuery(GET_FANTASY_ARTICLE_VIEWS, {
    onCompleted: data => {
      if (data && data?.getFrontFantasyArticle) {
        setArticleViews(data?.getFrontFantasyArticle?.nViewCount || data?.getFrontFantasyArticle?.nOViews || 0)
      }
    }
  })

  useEffect(() => {
    const slug = router?.asPath?.split('/').filter(e => e)
    const { lastSlug } = checkPageNumberInSlug(slug)
    setPage(lastSlug ? Number(lastSlug) || 1 : 1)
  }, [router?.asPath])

  useEffect(() => {
    if (article?.oSeo?.eType === 'ar') {
      // updateNewsArticleViews({ variables: { input: { _id: article?._id } } })
      getArticleViews({ variables: { input: { _id: article?._id } } })
    } else {
      // updateFantasyArticleViews({ variables: { input: { _id: article?._id } } })
      getFantasyArticleViews({ variables: { input: { _id: article?._id } } })
    }
  }, [])

  const { addRight, addLeft, addBottom, add300 } = reviveAdData

  return (
    <Layout data={{ ...article, oSeo: { ...article?.oSeo, ...seoData } }} isPreviewMode={isPreviewMode}>
      {/* <ChessPopAdMweb /> */}
      <main className={`${styles.articlePage}`}>
        <section className={`common-section ${type === 'fantasyArticle' ? 'pt-3' : 'pt-3 pt-md-4'}`}>
          <ATSAds />
          <div className="container">
            <div className="row justify-content-center justify-content-lg-start">
              <div className="col-lg-3 common-sidebar bt-width isDesk">
                {!isPreviewMode && (
                  <>
                    {/* <StaticBannerSecond adType="secondAd_Rect" link="article_left_banner" /> */}
                    <LazyLoad>
                      {isFootball ? <TrendingNewsArticle /> : <TrendingNewsArticle />}
                      <AllWidget type={WIDGET.fantasyTips} show />
                    </LazyLoad>
                  </>
                )}
                {/* <GoogleAds
                  addId={skyAddData?.addRight?.addId}
                  divId={skyAddData?.addRight?.divId}
                  dimension={skyAddData?.addRight?.dimension}
                  slotId={skyAddData?.addRight?.slotId}
                  className={'mb-4 sticky_ads'}
                /> */}
                <ReviveAds {...addRight} className={'d-flex justify-content-center mb-4 sticky_ads'}/>
              </div>
              <div className='col-lg-6'>
                <section className={`${styles.articleBlock} pb-2 mb-2 pt-0 position-relative`}>
                  <div
                    className={`d-flex align-items-start justify-content-between ${
                      article?.oAdvanceFeature?.bEditorsPick && article?.oAdvanceFeature?.bExclusiveArticle && 'flex-column flex-sm-row'
                    }`}>
                    {!isPreviewMode && <BreadcrumbNav listicleCurrentPage={page} />}
                    <div className="d-flex mb-2 mb-md-0">
                      {article?.oAdvanceFeature?.bEditorsPick && (
                        <span className={`badge bg-light" ${styles.advFeature} d-flex align-items-center text-capitalize`}>
                          <EditorsPickIcon />
                          {t('common:EditorsPick')}
                        </span>
                      )}
                      {article?.oAdvanceFeature?.bExclusiveArticle && (
                        <span className={`badge bg-light" ${styles.advFeature} d-flex align-items-center text-capitalize ms-2`}>
                          <ExclusiveIcon />
                          {t('common:ExclusiveArticle')}
                        </span>
                      )}
                    </div>
                    {article?._id === '63a40babfdaa420306916fd6' && <p className={`text-danger ${styles.liveUpdate}`}>LIVE</p>}
                  </div>
                  {/* <article className="article-details-page"> */}

                  <article>
                    {/* <h1 className={`${styles.title}`}>{article?.sTitle}</h1> */}
                    <div className={`${styles.authorBlock} d-flex flex-wrap align-items-center mb-3 mb-lg-4 mt-1`}>
                      {article.iEventId ? (
                        <span className={`${styles.liveblog} text-uppercase d-none d-sm-block position-relative me-4 `}>
                          {t('common:Liveblog')}
                        </span>
                      ) : null}
                      <div className={`${styles.author} d-flex align-items-center big-text font-semi text-capitalize`}>
                        <span>
                          {article?.oDisplayAuthor?.oSeo?.sSlug ? (
                            <CustomLink href={allRoutes.authorDetail(article?.oDisplayAuthor?.oSeo?.sSlug)} prefetch={false}>
                              <a>{article?.oDisplayAuthor?.sDisplayName}</a>
                            </CustomLink>
                          ) : (
                            article?.oDisplayAuthor?.sDisplayName
                          )}
                          {article?.oDisplayAuthor?.bIsVerified && (
                            <span className={`${styles.verfied} d-inline-block rounded-circle ms-1`}></span>
                          )}
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <p className={`${styles.views} d-flex align-items-center mb-0 text-capitalize`}>
                          <MyImage src={View} alt="Calendar Icon" height="18" width="18" />
                          <span className="ms-2">
                            {t('common:Views')} : {abbreviateNumber(articleViews)}
                          </span>
                        </p>
                        <p className={`${styles.views} ${styles.duration} d-flex align-items-center mb-0`}>
                          {article?.nDuration > 0 ? article?.nDuration : DEFAULT_BLOG_READ} {t('common:Minute')} {t('common:Read')}
                        </p>
                      </div>
                      <p className={`${styles.dates} w-100 xsmall-text font-semi mt-2 mb-0`}>
                        {(article?.dPublishDisplayDate || article?.dPublishDate) && (
                          <>
                            <time
                              className="op-published"
                              dateTime={dateCheck(article?.dPublishDisplayDate || article?.dPublishDate)?.toISOString()}>
                              {t('common:Published')} -{' '}
                              {convertDt24hFormat(dateCheck(article?.dPublishDisplayDate || article?.dPublishDate))}
                            </time>
                          </>
                        )}
                      </p>
                      {article.iEventId ? (
                        <span className={`${styles.liveblog} text-uppercase d-sm-none position-relative me-4 `}>
                          {t('common:Liveblog')}
                        </span>
                      ) : null}
                    </div>
                    {page <= 1 && (
                      <figure className="op-tracker">
                        <div className={`${styles.postImg} position-relative overflow-hidden`}>
                          <MyImage
                            priority={true}
                            src={getImgURL(article?.oImg?.sUrl) || noImage}
                            alt={article?.oImg?.sText || article?.sSrtTitle}
                            placeholder="blur"
                            blurDataURL={BLUR_DATA_URL_BASE64}
                            height="160"
                            width="256"
                            layout="responsive"
                            sizes="(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px"
                          />
                          <div className={`${styles.titleContent} d-flex flex-column`}>
                            <h1 className={styles.hOveride}>{article?.sTitle}</h1>
                            {article?.oImg?.sCaption !== 'null' && (
                              <figcaption className={`${styles.caption}`} dangerouslySetInnerHTML={{ __html: article?.oImg?.sCaption }} />
                            )}
                          </div>
                        </div>
                      </figure>
                    )}

                    <div className={`${styles.articleActionsMob} text-center`}>
                      {!isPreviewMode && <ArticleActions commentCount={commentCount} article={article} type={type} seoData={seoData} />}
                    </div>
                    {/* <div className="container w-full d-none d-md-flex justify-content-center">
                      <GoogleAds
                        addId={googleAddData?.addTop?.addId}
                        divId={googleAddData?.addTop?.divId}
                        dimension={googleAddData?.addTop?.dimension}
                        slotId={googleAddData?.addTop?.slotId}
                      />
                    </div> */}
                    {/* <div className="w-full d-flex d-md-none justify-content-center">
                      <GoogleAds
                        addId={googleAddData?.mobSm?.addId}
                        divId={googleAddData?.mobSm?.divId}
                        dimension={googleAddData?.mobSm?.dimension}
                        slotId={googleAddData?.mobSm?.slotId}
                      />
                    </div> */}
                    {children}
                  </article>
                  {/* <StaticBannerSecond adType="secondAd_long" link="article_bottom_banner" /> */}
                  {/* <div className='d-md-none'>
                    <StaticBannerSecond adType='secondAdRect_Left' link='article_mweb_bottom_banner'/>
                  </div> */}
                  <div className="d-flex justify-content-center d-md-none">
                    {/* <GoogleAds
                      addId={skyAddData?.addRight?.addId}
                      divId={skyAddData?.addRight?.divId}
                      dimension={skyAddData?.addRight?.dimension}
                      slotId={skyAddData?.addRight?.slotId}
                      className={'mb-4'}
                    /> */}
                    <ReviveAds {...addLeft} className={'mb-4'}/>
                  </div>
                  {article?.oAdvanceFeature?.bAllowComments && (
                    <OnMouseAndScroll>
                      <Comments
                        type={type}
                        commentCount={commentCount}
                        setCommentCount={setCommentCount}
                        articleId={article?._id}
                        count={article?.nCommentCount}
                        isRequireAdminApproval={article?.oAdvanceFeature?.bRequireAdminApproval}
                      />
                    </OnMouseAndScroll>
                  )}
                  {width > 991 && (
                    //  <GoogleAds
                    //   addId={googleNewAdsData?.homePage?.hotStory?.web?.addId}
                    //   divId={googleNewAdsData?.homePage?.hotStory?.web?.divId}
                    //   dimension={googleNewAdsData?.homePage?.hotStory?.web?.dimension}
                    //   slotId={googleNewAdsData?.homePage?.hotStory?.web?.slotId}
                    //   className={'mt-0 mb-4'}
                    // />
                    <ReviveAds {...addBottom} className={'mt-4 mb-4'}/>
                  )}
                  <OnMouseAndScroll>
                    <TrendingNewsArticle isSlider ePlatform={isFootball ? 'f' : ''} />
                  </OnMouseAndScroll>
                  <div className="d-md-none">
                    <StaticBanner isLeft />
                  </div>
                  {/* <OnMouseAndScroll> */}
                  {/* <DownloadApp isArticle isDesk /> */}
                  {/* </OnMouseAndScroll> */}
                </section>
                {/* Desktop/Mobile above related Video and article  */}
                {/* <div ref={observe}>
                  {(!isPreviewMode && inView) && (
                    <> */}
                {/* {(width < 768) && <PixFuture />} */}
                {/* {(width > 768 && (article?.oCategory?._id || article?.iCategoryId)) && (
                        <ArticleRelatedVideos categoryId={article?.oCategory?._id || article?.iCategoryId} articleId={article?._id} type={article?.oSeo?.eType} />
                      )} */}
                {/* <ErrorBoundary>
                        <TaboolaAds />
                      </ErrorBoundary> */}
                {/* </>
                  )}
                </div> */}
              </div>
              <div className="col-lg-3 common-sidebar bt-width isDesk">
                {!isPreviewMode && (
                  <>
                    {article?.iEventId ? (
                      <LiveBlog data={liveArticle} />
                    ) : (
                      <>
                        <StaticBanner isLeft />
                        <LazyLoad>
                          {isFootball ? (
                            <>
                              <TopTeams ePlatform={isFootball ? 'f' : ''} />
                              <TrendingSeries />
                              {/* <GoogleAds
                                addId={googleAddData?.addRight?.addId}
                                divId={googleAddData?.addRight?.divId}
                                dimension={googleAddData?.addRight?.dimension}
                                slotId={googleAddData?.addRight?.slotId}
                                className={'my-3 sticky_ads'}
                              /> */}
                              <ReviveAds {...addRight} className={'my-3 sticky_ads'}/>
                            </>
                          ) : isTennis ? (
                            <>
                              <TopTennisPlayers />
                              {/* <GoogleAds
                                addId={googleAddData?.addRight?.addId}
                                divId={googleAddData?.addRight?.divId}
                                dimension={googleAddData?.addRight?.dimension}
                                slotId={googleAddData?.addRight?.slotId}
                                className={'my-3 sticky_ads'}
                              /> */}
                              <ReviveAds {...addRight} className={'my-3 sticky_ads'}/>
                            </>
                          ) : (
                            <>
                              <AllWidget type={WIDGET.upcomingMatches} show />
                              {/* <GoogleAds
                                addId={googleAddData?.addRight?.addId}
                                divId={googleAddData?.addRight?.divId}
                                dimension={googleAddData?.addRight?.dimension}
                                slotId={googleAddData?.addRight?.slotId}
                                className={'mb-4'}
                                /> */}
                              <ReviveAds {...addRight} className={'mb-4'}/>
                              <AllWidget type={WIDGET.topTeams} show />
                              <ReviveAds {...add300} className={'mb-4'}/>
                              <AllWidget type={WIDGET.trendingPlayers} show />
                            </>
                          )}
                        </LazyLoad>
                        <ATSAds />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

ArticleDetail.propTypes = {
  article: PropTypes.object,
  liveArticle: PropTypes.object,
  seoData: PropTypes.object,
  isPreviewMode: PropTypes.bool,
  children: PropTypes.node.isRequired,
  type: PropTypes.string
  // currentSeriesData: PropTypes.object
}

export default ArticleDetail
